module.exports = __webpack_public_path__ + "img/md-phone_android Copy.a0b2b010.svg";